<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" title="Part1">
<p class="pnum" id="part1"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><a href="#/text/nav#r_part1">Building Trust</a><span class="right_1" epub:type="pagebreak" id="page_2" title="2"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780785217367_Part1.vue?d9cff18c